import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';

import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getDatabase, provideDatabase } from '@angular/fire/database';
import { getFunctions, provideFunctions } from '@angular/fire/functions';
import { environment } from '../environments/environment';

import { routes } from './app.routes';
import { ANALYTICS_SERVICE_TOKEN } from './core/tokens/analytics-service.token';
import { MockAnalyticsService } from './core/services/mock-analytics.service';
import { FirestoreAnalyticsService } from './core/services/firestore-analytics.service';

const firebaseDb: any = environment.db;
const config = { ...firebaseDb.config, ...(firebaseDb.insights || {}) };

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideAnimations(),
    provideRouter(routes),
    provideHttpClient(),
    provideFirebaseApp(() => initializeApp(config)),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    provideDatabase(() => getDatabase()),
    provideFunctions(() => getFunctions()),
    {
      provide: ANALYTICS_SERVICE_TOKEN,
      useClass: environment.useMockData ? MockAnalyticsService : FirestoreAnalyticsService
    }
  ]
};
